import { Box, Center, Flex, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { IconType } from '@react-icons/all-files';
import { FaCommentDots } from '@react-icons/all-files/fa/FaCommentDots';
import { FaUsers } from '@react-icons/all-files/fa/FaUsers';

import WaitingHeader from './waiting/WaitingHeader';

type OfferStep = {
  icon: IconType;
  title: string;
  description: string;
};

const STEPS: OfferStep[] = [
  {
    icon: FaUsers,
    title: 'Buyers are reviewing',
    description: "They're looking now, and they'll send offers when they're ready.",
  },
  {
    icon: FaCommentDots,
    title: "We'll reach out",
    description: "We'll text and email the moment an offer lands.",
  },
];

const OffersWaitingSteps = () => (
  <VStack spacing={{ base: 7, md: 9 }} w="100%">
    <WaitingHeader
      heading="Your car is in front of buyers."
      subline="No offers yet. Here's what's happening while you wait."
    />

    <VStack align="stretch" spacing={0} w="100%" maxW="360px">
      {STEPS.map((step, index) => {
        const isLast = index === STEPS.length - 1;
        return (
          <HStack key={step.title} align="stretch" spacing={4}>
            <Flex direction="column" align="center">
              <Center
                w="40px"
                h="40px"
                borderRadius="full"
                bg="iceBlue"
                color="oceanBoatBlue"
                flexShrink={0}
              >
                <Icon as={step.icon} boxSize="16px" />
              </Center>
              {!isLast && <Box w="2px" flex="1" minH="16px" my={1} bg="grayMediumBackground" />}
            </Flex>
            <Box pt="6px" pb={isLast ? 0 : 6}>
              <Text fontSize="14px" fontWeight="700" color="grayDark" lineHeight="1.3">
                {step.title}
              </Text>
              <Text fontSize="12.5px" color="grayLight" lineHeight="1.45" mt="2px">
                {step.description}
              </Text>
            </Box>
          </HStack>
        );
      })}
    </VStack>
  </VStack>
);

export default OffersWaitingSteps;
